const Pagination = ({ pagination }) => {

    const handleClick = (event) => {
        window.location.href = event.currentTarget.id;
    };


    /* Modern button styles */
    const baseBtn = {
        minWidth: "24px",
        height: "24px",
        padding: "0 8px",
        margin: "2px",
        marginTop: "5px",
        borderRadius: "10px",
        border: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        fontSize: "10px",
        fontWeight: "500",
        transition: "all 0.22s ease",
        color: "white",
        boxSizing: "border-box"
    };

    const palette = {
        correct: { background: "linear-gradient(135deg, #4caf50, #2e7d32)", fontSize: "12px" },
        wrong: { background: "linear-gradient(135deg, #d32f2f, #b71c1c)", fontSize: "12px" },
        empty: { background: "linear-gradient(135deg, #9e9e9e, #616161)", fontSize: "11px" },
    };

    const activeStyle = {
        transform: "scale(1.13)",
        boxShadow: "0 0 10px rgba(0,200,255,0.8)",
        border: "2px solid rgb(0,200,255)",
    };

    return (

        <>
            {/* Mobile override */}
            <style>
                {`
                  .pagination-bar {
            position: fixed;
            bottom: 0;
            left: 250px;
            width: calc(100% - 250px);
            background-color: #fff;
            border-top: 1px solid #ccc;
            padding: 2px;
            z-index: 9999;
            transition: all 0.25s ease;
          }
            
          /* ===== SIDEBAR COLLAPSED ===== */
          body.sidebar-collapsed .pagination-bar {
            left: 80px;
            width: calc(100% - 65px);
          }
                @media (max-width: 992px) {
                    .pagination-bar {
                        left: 0 !important;
                        width: 100% !important;
                    }
                }
            `}
            </style>
            <style>

                {`
    /* Accordion default arrow'ı gizle */
    .accordion-button::after {
        display: none !important;
    }
.accordion-header {
    margin: -5 !important;
}
    /* Bootstrap paddingleri kaldır */
    .accordion-button.custom-center {
        padding-left: 0 !important;
        padding-right: 0 !important;
        text-align: center !important;
        justify-content: center !important;
    }

    /* Başlık tam ortada */
    .accordion-button.custom-center span {
        width: 100%;
        text-align: center;
        display: block;
    }
`}

            </style>

            {/* ======== FIXED BOTTOM BAR + ACCORDION ======== */}
            <div
                className="pagination-bar"
                style={{
                    position: "fixed",
                    bottom: 0,
                    backgroundColor: "#fff",
                    borderTop: "1px solid #ccc",
                    padding: "1px",
                    zIndex: 9999,
                    boxSizing: "border-box"
                }}
            >
                {/* ======== Accordion ======== */}
                <div className="accordion" id="paginationAccordion">
                    <div className="accordion-item" >
                        <h2 className="accordion-header" >
                            <button
                                className="accordion-button collapsed custom-center"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#paginationBody"
                            >
                                <span style={{ position: "relative", paddingRight: "5px" }}>
                                    <b>SORULARI GÖR</b>    <i class="fas fa-chevron-down soru-arrow"></i>

                                </span>
                            </button>
                        </h2>

                        <div
                            id="paginationBody"
                            className="accordion-collapse collapse"
                            data-bs-parent="#paginationAccordion"
                        >

                            {/* ======== LEGEND ======== */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "40px",
                                    marginTop: "8px",
                                    flexWrap: "wrap",
                                    fontSize: "14px",
                                    fontWeight: 600
                                }}
                            >
                                {/* 1 - Correct */}
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <div style={{
                                        width: "18px",
                                        height: "18px",
                                        borderRadius: "2px",
                                        background: "linear-gradient(135deg, #4CAD2F)"
                                    }}></div>
                                    <span>Doğru çözülmüş</span>
                                </div>

                                {/* 2 - Wrong */}
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <div style={{
                                        width: "18px",
                                        height: "18px",
                                        borderRadius: "2px",
                                        background: "linear-gradient(135deg, #d32f2f, #b71c1c)"
                                    }}></div>
                                    <span>Hatalı çözülmüş</span>
                                </div>

                                {/* 3 - Empty */}
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <div style={{
                                        width: "18px",
                                        height: "18px",
                                        borderRadius: "2px",
                                        background: "linear-gradient(135deg, #9e9e9e, #616161)"
                                    }}></div>
                                    <span>Henüz çözülmemiş</span>
                                </div>
                            </div>


                            {/* ======== BUTTONS ======== */}
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "center",
                                    marginTop: "4px",
                                    marginRight: "5px",
                                    marginLeft: "5px",
                                }}
                            >
                                {pagination.map((dt) => {

                                    let style = { ...baseBtn };
                                    if (dt.answered) {
                                        style = { ...style, ...(dt.answerCorrect ? palette.correct : palette.wrong) };
                                    } else {
                                        style = { ...style, ...palette.empty };
                                    }
                                    if (dt.isActive) style = { ...style, ...activeStyle };

                                    return (
                                        <button
                                            key={dt.id}
                                            id={dt.href}
                                            style={style}
                                            onClick={handleClick}
                                        >
                                            {dt.id}
                                        </button>
                                    );
                                })}
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default Pagination;
